import React from "react";
import cx from "classnames";

import styles from "./styles.module.scss";

export interface CascadingActionsBannerProps {
  dayDifference: number;
  noOfCascadingActions: number;
  actionItemName: string;
  cascadeActions: () => void | Promise<void>;
  closeBanner: () => void;
  cascadeLoading?: boolean;
}

const CascadingActionsBanner = ({
  dayDifference,
  noOfCascadingActions,
  actionItemName,
  cascadeActions,
  closeBanner,
  cascadeLoading = false,
}: CascadingActionsBannerProps) => {
  const absDays = Math.abs(dayDifference);
  const dayWord = absDays === 1 ? "day" : "days";
  const itemWord = noOfCascadingActions === 1 ? "item" : "items";
  const directionLater = dayDifference >= 0;
  const displayedActionItemName = actionItemName || "this action item";

  const shiftPhrase = directionLater
    ? `Shift ${noOfCascadingActions} subsequent ${itemWord} forward by ${absDays} ${dayWord}?`
    : `Shift ${noOfCascadingActions} subsequent ${itemWord} backward by ${absDays} ${dayWord}?`;

  return (
    <div
      className={styles.cascadingActionsBanner}
      role="region"
      aria-live="polite"
      aria-busy={cascadeLoading}
    >
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <i className={cx(styles.calendarIcon, "paperflite-calendar")} aria-hidden />
          <span className={styles.title}>
            Action Items Schedule Shift ({noOfCascadingActions})
          </span>
        </div>
        <button
          type="button"
          className={styles.closeButton}
          aria-label="Close"
          onClick={closeBanner}
          disabled={cascadeLoading}
        >
          <i className={cx(styles.closeIcon, "paperflite-close")} aria-hidden />
        </button>
      </div>
      <div className={styles.footer}>
        <p className={styles.message}>
          You&apos;ve moved <span className={styles.highlight}>{displayedActionItemName}&apos;s</span> date {absDays}{" "}
          {dayWord} {directionLater ? "later" : "earlier"}. {shiftPhrase}
        </p>
        <button
          type="button"
          className={styles.shiftDates}
          onClick={() => void cascadeActions()}
          disabled={cascadeLoading}
        >
          <i className={cx(styles.shiftIcon, "paperflite-tick")} aria-hidden />
          Shift dates
        </button>
      </div>
    </div>
  );
};

export default CascadingActionsBanner;
